export default "__VITE_ASSET__BixDVrwJ__"